import React, { createContext } from 'react';

import { BrowserRouter as ReactRouter } from 'react-router-dom';

import context from './../context';

export const AuthContext = createContext();

export default class Router extends ReactRouter {
  static defaultProps = ReactRouter.defaultProps;

  state = {
    loading: true,
    user: undefined,
  };

  constructor() {
    super(...arguments);

    this.sessionChangeListener = this._setSessionState.bind(this);
  }

  _setSessionState({ account, loading }) {
    this.setState({
      loading: loading,
      user: account,
    });
  }

  componentDidMount() {
    this._setSessionState(context.sessionStore.get());
    context.sessionStore.addListener('changed', this.sessionChangeListener);
  }

  componentWillUnmount() {
    if (typeof super.componentWillUnmount === 'function') {
      super.componentWillUnmount();
    }
    context.sessionStore.removeListener('changed', this.sessionChangeListener);
  }

  render() {
    const contextValue = {
      token: localStorage.getItem('token'),
      authenticated: !!localStorage.getItem('token'),
      loading: this.state.loading,
      user: this.state.user,
    };

    return <AuthContext.Provider value={contextValue}>{super.render()}</AuthContext.Provider>;
  }
}
